import { render, staticRenderFns } from "./ProjectsDoingCard.vue?vue&type=template&id=162e331e&scoped=true"
import script from "./ProjectsDoingCard.vue?vue&type=script&lang=js"
export * from "./ProjectsDoingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e331e",
  null
  
)

export default component.exports